/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORTS : STYLES--------------- ++++++++++ */
export default theme => ({
    reports: {
        '& #subhead': {
            '& .reportname': {
                animationDelay: '.45s'
            }
        },
    	// animate in copy and details on load
        '& .name-page-copy': {
        	opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.1s',
        },
        '& .name-page-details': {
        	opacity: '0',
        	animationName: 'fadeInUp',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            animationDelay: '.175s',
        }
    }
});